// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__K85zn","bordered":"Table_bordered__27oLy","minWidth":"Table_minWidth__29JCi","head":"Table_head__1E34p","spinAround":"Table_spinAround__2YLvP"};